import { useCopies } from "../../../../../shared/hooks/useCopies";
import DateTimeHelper from "shared/utils/dateTimeHelper";

export default function DateTimeDisplayCell(props: { date?: string; timezoneDisplayStr?: string }) {
  const copies = useCopies();
  const dateDisplayValue = props.date
    ? DateTimeHelper.formatDate({
        startDate: props.date,
        timeZone: props.timezoneDisplayStr,
        option: {
          showTime: true,
          showWeekDay: true
        }
      })
    : copies.get("empty.cell");

  return (
    <div className="td_ellipsis" title={dateDisplayValue}>
      {dateDisplayValue}
    </div>
  );
}
